export const TAB_NAMES = {
  swap: 'Swap',
  // limit: 'Limit',
}
